import { createServerFn } from '@tanstack/react-start';
import { getRequest } from '@tanstack/react-start/server';

import { getUserWatchlists } from '~/database/supabase/watchlist/queries.server.ts';
import type { WatchlistWithAllRelationsType } from '~/database/supabase/watchlist/types.ts';
import { getHints } from '~/utils/client-hints.tsx';

import { requireStartAuthSession } from '../auth/require-start-auth-session.ts';
import { createServerFnObservabilityMiddleware } from '../utils/create-instrumented-server-fn.ts';

export interface WatchlistPageData {
	readonly userLocale: string;
	readonly watchlistIndex: number;
	readonly watchlists: WatchlistWithAllRelationsType[];
}

export const getWatchlistPageData = createServerFn({ method: 'GET' })
	.middleware([
		createServerFnObservabilityMiddleware({
			dependencies: ['auth.session', 'supabase.watchlist.full'],
			relatesTo: 'watchlist.page',
		}),
	])
	.inputValidator((data: { watchlistIndex: number }) => data)
	.handler(async ({ data }): Promise<WatchlistPageData> => {
		const request = getRequest();
		const authSession = await requireStartAuthSession({ request });
		const userLocale = getHints(request).locale;
		const watchlists = await getUserWatchlists(authSession.userId);

		return {
			userLocale,
			watchlistIndex: data.watchlistIndex,
			watchlists,
		};
	});
